import window from 'core/includes/window';

export const up = (levels: number) => {
    const levelsArray = window.location?.pathname?.split("/")?.filter((str: string) => str !== "");

    return `/${levelsArray.slice(0, 0 - levels).join("/")}`;
}
